import React, { useState, useEffect, useCallback } from "react";
import { formatRupiah } from "../../../../helper/formatNumber";
import { Constant } from "../../../../helper/constant";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import "./inputDoctorTreatmentTransaction.css";

const InputDoctorTreatmentTransaction = ({
  doctorTreatmentTransactionData,
  setDoctorTreatmentTransactionData,
}) => {
  // =====================
  // Constant
  // =====================
  const navigate = useNavigate();
  const [suggestionDoctorTreatment, setSuggestionDoctorTreatment] = useState(
    []
  );
  const [activeInputIndex, setActiveInputIndex] = useState(null);

  // =====================
  // Method
  // =====================

  const addTreatment = useCallback(() => {
    setDoctorTreatmentTransactionData((prevData) => [
      ...prevData,
      {
        treatment_id: "",
        treatment_name: "",
        treatment_total_price: 0,
      },
    ]);
    setSuggestionDoctorTreatment([]);
  }, [setDoctorTreatmentTransactionData]);

  const handleEnterPress = useCallback(
    (event) => {
      if (event.key === "Enter") {
        console.log("Enter key pressed!");
        addTreatment();
      }
    },
    [addTreatment]
  );

  const removeProduct = (index) => {
    setDoctorTreatmentTransactionData((prevData) =>
      prevData.filter((_, i) => i !== index)
    );
  };

  const handleInputChange = (index, field, value) => {
    if (field === "treatment_name") {
      checkTreatmentAutoComplete(value);
    }
    setDoctorTreatmentTransactionData((prevData) =>
      prevData.map((product, i) =>
        i === index ? { ...product, [field]: value } : product
      )
    );
  };

  const checkTreatmentAutoComplete = (keyword) => {
    if (keyword.length > 1) {
      findTreatment(keyword);
    } else {
      setSuggestionDoctorTreatment([]);
    }
  };

  const updateTreatmentData = (index, treatments) => {
    setDoctorTreatmentTransactionData((prevData) =>
      prevData.map((treatment, i) =>
        i === index
          ? {
              ...treatment,
              treatment_id: treatments.doctor_treatment_id,
              treatment_name: treatments.doctor_treatment_name,
              treatment_total_price: treatments.doctor_treatment_price,
            }
          : treatment
      )
    );
  };

  // =====================
  // Request Method
  // =====================

  const findTreatment = async (keyword) => {
    try {
      const response = await fetch(
        Constant.BASE_API_URL +
          "/tindakan-medis/autocomplete?keyword=" +
          keyword,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: "bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (!response.ok) {
        alert("Terdapat Kesalahan Dalam Memproses Data");
        if (response.status === 401 || response.status === 403) {
          localStorage.clear();
          return navigate("/login", { replace: true });
        }
      }

      const json = await response.json();
      const data = json.data;
      setSuggestionDoctorTreatment(data.doctor_treatments);
    } catch (error) {
      setSuggestionDoctorTreatment([]);
    }
  };

  useEffect(() => {
    window.addEventListener("keydown", handleEnterPress);

    return () => {
      window.removeEventListener("keydown", handleEnterPress);
    };
  }, [handleEnterPress]);

  return (
    <div className="input-doctor-treatment-transaction-container">
      <div className="input-list-treatment-titles">
        <span>Tindakan Medis</span>
        <span>Total Harga</span>
      </div>
      {doctorTreatmentTransactionData.map((treatment, index) => (
        <div className="input-list-treatment-container" key={index}>
          <input
            className="input-field-product"
            type="text"
            value={treatment.treatment_name ? treatment.treatment_name : ""}
            onChange={(e) =>
              handleInputChange(index, "treatment_name", e.target.value)
            }
            onFocus={() => {
              setActiveInputIndex(index);
              setSuggestionDoctorTreatment([]);
            }}
            placeholder="Masukkan nama tindakan"
          />
          {suggestionDoctorTreatment.length > 0 &&
            activeInputIndex === index && (
              <ul className="dropdown-list-product-transaction">
                {suggestionDoctorTreatment.map((treatment) => (
                  <li key={treatment.doctor_treatment_id}>
                    <button
                      className="dropdown-button"
                      onClick={() => {
                        updateTreatmentData(activeInputIndex, treatment);
                        setSuggestionDoctorTreatment([]);
                      }}
                    >
                      {treatment.doctor_treatment_name} | Harga Jasa:{" "}
                      <b>{treatment.doctor_treatment_price}</b>
                    </button>
                  </li>
                ))}
              </ul>
            )}
          <input
            className="input-field-product"
            type="text"
            value={
              treatment.treatment_total_price
                ? formatRupiah(Number(treatment.treatment_total_price))
                : "Rp 0"
            }
            onInput={(e) => {
              e.target.value = e.target.value.replace(/\D/g, "");
            }}
            onChange={(e) =>
              handleInputChange(index, "treatment_total_price", e.target.value)
            }
            onFocus={() => setActiveInputIndex(null)}
            placeholder="Masukkan harga tindakan medis"
            disabled={true}
          />
          {doctorTreatmentTransactionData.length > 1 && (
            <MdDelete
              className="remove-product-list"
              onClick={() => {
                removeProduct(index);
              }}
            />
          )}
        </div>
      ))}
      <button
        className="add-more-product-item"
        type="button"
        onClick={addTreatment}
      >
        Tambah Tindakan Medis Lagi
      </button>
    </div>
  );
};

export default InputDoctorTreatmentTransaction;
